import { useState } from 'react';
import { Button } from '../ui/Button';
import { Textarea } from '../ui/Input';
import { Modal } from '../ui/Modal';
import { CheckCircle2, ShieldAlert } from 'lucide-react';

interface AlertClosureModalProps {
  alertId: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (id: string, reason: string) => void;
}

const CLOSURE_CATEGORIES = [
  'Falsa Alerta / Calibración Sensor',
  'Conductor Contactado & Advertido',
  'Atendido por Supervisor en Ruta',
  'Falla Mecánica Solucionada',
  'Protocolo de Emergencia Activado',
  'Otro Motivo Documentado',
];

export function AlertClosureModal({ alertId, isOpen, onClose, onConfirm }: AlertClosureModalProps) {
  const [category, setCategory] = useState(CLOSURE_CATEGORIES[1]);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const handleConfirm = () => {
    const fullReason = `[${category}] ${reason.trim()}`;
    if (reason.trim().length < 5) {
      setError('Por favor detalla brevemente el motivo del cierre (mínimo 5 caracteres).');
      return;
    }
    onConfirm(alertId, fullReason);
    setReason('');
    setError('');
    onClose();
  };

  const handleClose = () => {
    setReason('');
    setError('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Resolución & Cierre Documentado de Alerta"
      size="sm"
      footer={
        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', width: '100%' }}>
          <Button variant="ghost" onClick={handleClose}>Cancelar</Button>
          <Button variant="danger" onClick={handleConfirm} leftIcon={<CheckCircle2 size={15} />}>
            Confirmar y Trasladar a Histórico
          </Button>
        </div>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.75rem 1rem', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.25)', borderRadius: 'var(--radius-lg)', color: '#EF4444' }}>
          <ShieldAlert size={20} />
          <span style={{ fontSize: '12.5px', fontWeight: 600 }}>
            Al cerrar esta alerta se trasladará al histórico del conductor vinculado junto con su motivo de cierre y clip de video asociado.
          </span>
        </div>

        <div>
          <label style={{ fontSize: '12px', fontWeight: 700, color: 'var(--text-secondary)', display: 'block', marginBottom: '4px' }}>
            Categoría de Resolución *
          </label>
          <select
            value={category}
            onChange={e => setCategory(e.target.value)}
            style={{ width: '100%', padding: '0.625rem', background: 'var(--bg-raised)', color: 'var(--text-primary)', border: '1px solid var(--border-strong)', borderRadius: 'var(--radius-md)', fontSize: '13px', outline: 'none' }}
          >
            {CLOSURE_CATEGORIES.map(cat => <option key={cat} value={cat}>{cat}</option>)}
          </select>
        </div>

        <Textarea
          label="Comentario / Detalle de cierre *"
          id="closure-reason"
          rows={3}
          placeholder="Describe la instrucción dada al conductor o la acción realizada..."
          value={reason}
          onChange={e => { setReason(e.target.value); setError(''); }}
          error={error}
        />
      </div>
    </Modal>
  );
}
